const CompanysAhan = [
    {ID: -1 , Name : "همه موارد" , CompanyCategoryId: [2001 , 2002 , 2003 ,2004]},
    {ID: 1 , Name : "تهران" , CompanyCategoryId: [2001]},
    {ID: 2 , Name : " فولاد مازندران" , CompanyCategoryId: [2001]},
    {ID: 3 , Name : "کالوپ" , CompanyCategoryId: [2001]},
    {ID: 4 , Name : "اصفهان" , CompanyCategoryId: [2001 , 2004]},
    {ID: 5 , Name : "آریان فولاد" , CompanyCategoryId: [2002 , 2004]},
    {ID: 6 , Name : " شکفته" , CompanyCategoryId: [2002]},
    {ID: 7 , Name : " ناب تبریز " , CompanyCategoryId: [2002]},
    {ID: 8 , Name : " فولادکوهپایه " , CompanyCategoryId: [2002]},
    {ID: 9 , Name : "ظهوریان" , CompanyCategoryId: [2002]},
    {ID: 10 , Name : "آونگان" , CompanyCategoryId: [2002]},
    {ID: 11 , Name : "منظومه" , CompanyCategoryId: [2002]},
    {ID: 12 , Name : "سپهر ایرانیان" , CompanyCategoryId: [2002 , 2004]},
    {ID: 13 , Name : "جاوید بناب" , CompanyCategoryId: [2002]},
    {ID: 14 , Name : "ماهان ذوب" , CompanyCategoryId: [2002]},
    {ID: 15 , Name : "نستا" , CompanyCategoryId: [2002]},
    {ID: 16 , Name : "ابهر" , CompanyCategoryId: [2002 , 2004]},
    {ID: 17 , Name : "زنجان" , CompanyCategoryId: [2002]},
    {ID: 18 , Name : "اشتهارد" , CompanyCategoryId: [2002]},
    {ID: 19 , Name : "ذوب آهن" , CompanyCategoryId: [2003]},
    {ID: 20 , Name : "فایکو" , CompanyCategoryId: [2003 , 2004]},
    {ID: 21 , Name : "یزد" , CompanyCategoryId: [2003]},
    {ID: 22 , Name : "اطلس" , CompanyCategoryId: [2003]},
    {ID: 23 , Name : "بناب" , CompanyCategoryId: [2003 , 2004]},
    {ID: 24 , Name : "ماهان" , CompanyCategoryId: [2003]},
    {ID: 25 , Name : "کرمانشاه" , CompanyCategoryId: [2003]},
    {ID: 26 , Name : "نیشابور" , CompanyCategoryId: [2004]},
    {ID: 27 , Name : "امیر کبیر" , CompanyCategoryId: [2004]},
    {ID: 28 , Name : "فولاد سیرجان" , CompanyCategoryId: [2004]},
    {ID: 29 , Name : "بافق یزد" , CompanyCategoryId: [2004]},
    {ID: 30 , Name : "شاهرود" , CompanyCategoryId: [2004]},
    {ID: 31 , Name : "شاهین بناب" , CompanyCategoryId: [2004]},
    {ID: 32 , Name : "فولاد زاگرس" , CompanyCategoryId: [2004]},
    {ID: 33 , Name : "همدان" , CompanyCategoryId: [2004]},
    {ID: 34 , Name : "آناهیتا گیلان" , CompanyCategoryId: [2004]},
    {ID: 35 , Name : "کاشان" , CompanyCategoryId: [2004]},
    {ID: 36 , Name : "قائم" , CompanyCategoryId: [2004]},
    {ID: 37 , Name : "سمنان" , CompanyCategoryId: [2004]},
    {ID: 38 , Name : "تیکمه داش" , CompanyCategoryId: [2004]},
    {ID: 39 , Name : "درپاد تبریز" , CompanyCategoryId: [2004]},
    {ID: 40 , Name : "کوثر اهواز" , CompanyCategoryId: [2004]},
    {ID: 41 , Name : "خلیج فارس" , CompanyCategoryId: [2004]},
    {ID: 42 , Name : "هیربد" , CompanyCategoryId: [2004]},
    {ID: 43 , Name : "ابرکوه" , CompanyCategoryId: [2004]},
    {ID: 44 , Name : "پردیس" , CompanyCategoryId: [2004]},
    {ID: 45 , Name : "پرشین فولاد" , CompanyCategoryId: [2004]},


]
export default CompanysAhan;